import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { StatusUpdateInterface } from '../../models/interfaces/update-status.interface'
import { BASEURL_POLYMER, SUB_PATH_BASIC } from '../../utils/api'

interface QueryParams {
  uinfin: string
  singpass_token: string
}

export const ongoingApplicationApi = createApi({
  reducerPath: 'ongoingApplicationApi',
  baseQuery: fetchBaseQuery({ baseUrl: BASEURL_POLYMER, 
  prepareHeaders:(headers,{getState})=>{
    headers.set("Access-Control-Request-Method", "GET");
    headers.set("X-Content-Type-Options", "nosniff");
  }}),
  endpoints: (builder) => ({
    getOngoingApplication: builder.query<StatusUpdateInterface[], QueryParams>({
      query: (queryParams:QueryParams) => ({
        method: "GET",
        headers: {
          uinfin:queryParams.uinfin,
          Authorization: `Bearer ${queryParams.singpass_token}`
        },
        url:`${SUB_PATH_BASIC}/getApplicationStatus`,
      }),
      keepUnusedDataFor:1,
    }),
  }),
})

export const { useGetOngoingApplicationQuery } = ongoingApplicationApi

